import { defineNuxtPlugin, useHead, useRuntimeConfig } from '#app'
import { useCountryConfig } from '~/composables/useCountryConfig'

export default defineNuxtPlugin(() => {
  const { hubspotBusinessUnitId } = useCountryConfig()
  const { hubspotChatEnabled } = useRuntimeConfig().public

  if (!hubspotChatEnabled || !hubspotBusinessUnitId)
    return

  // HubSpot's tracking script normally shows the widget automatically once
  // it finishes bootstrapping, but that relies on internal timing (e.g. the
  // browser's `load` event) that isn't reliable when the script is injected
  // dynamically (as opposed to being a static tag in the initial HTML) -
  // this is a known flakiness in HubSpot's own script, more likely to lose
  // the race on a warm/cached reload than on a cold fresh-tab load. Pushing
  // our own callback onto `hsConversationsOnReady` and explicitly calling
  // `widget.load()` makes the widget appear deterministically every time.
  window.hsConversationsOnReady = window.hsConversationsOnReady ?? []
  window.hsConversationsOnReady.push(() => {
    if (!window.HubSpotConversations?.widget.status().loaded)
      window.HubSpotConversations?.widget.load()
  })

  useHead({
    script: [
      {
        id: 'hs-script-loader',
        src: `https://js-eu1.hs-scripts.com/26993885.js?businessUnitId=${hubspotBusinessUnitId}`,
        async: true,
        defer: true,
        tagPosition: 'bodyClose',
      },
    ],
  })
})
